export default function isPositiveInteger(value) {
  // Check if the value is of type number and is a positive integer
  if (typeof value === "number" && Number.isInteger(value) && value >= 0) {
    return true;
  }

  // Check if the value is a string that represents a positive integer
  if (typeof value === "string") {
    const positiveIntegerRegex = /^[0-9]\d*$/;
    return positiveIntegerRegex.test(value);
  }

  // Return false for all other types
  return false;
}
